import { useEffect, useState } from "react";

const parts = (ms) => [
  ["Days", Math.floor(ms / 86400000)],
  ["Hrs", Math.floor(ms / 3600000) % 24],
  ["Min", Math.floor(ms / 60000) % 60],
  ["Sec", Math.floor(ms / 1000) % 60],
];

export const Countdown = ({ start, testId }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const target = new Date(start).getTime();
  if (!start || Number.isNaN(target)) return null;
  const left = target - now;
  if (left <= 0) {
    return <div className="inline-flex mt-5 rounded-sm bg-[#E60000] px-3 py-1.5 text-xs font-bold uppercase tracking-[0.18em]" data-testid={testId}>Happening now</div>;
  }
  return (
    <div className="flex gap-2 mt-6" data-testid={testId}>
      {parts(left).map(([label, v]) => (
        <div key={label} className="w-16 rounded-md bg-white/10 border border-white/15 backdrop-blur-md py-2 text-center">
          <div className="font-heading text-2xl font-extrabold tabular-nums leading-none">{String(v).padStart(2, "0")}</div>
          <div className="text-[10px] uppercase tracking-[0.16em] text-white/60 mt-1">{label}</div>
        </div>
      ))}
    </div>
  );
};
